import { create } from "@movicoders/store";
import { IWarehouse3DStore } from "./IWarehouse3DStore";
import { EMPTY_WAREHOUSE } from "../../mocked-data/empty-wh";
import { Warehouse3D } from "../../types/Warehouse3D";

export const useWarehouse3DStore = create<IWarehouse3DStore>((set, get) => ({
  warehouse: EMPTY_WAREHOUSE,
  getWarehouse: () => get().warehouse,
  setWarehouse: (newValue: Warehouse3D) => set((state) => ({ ...state, warehouse: newValue })),
})).build();